<template>
    <div>

        <!-- =============================================================================== -->

       <v-row justify="center">
          <v-dialog v-model="overlay" max-width="600px">
            <v-overlay :value="$store.state.isloading">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
            <v-card>
              <v-card-title>
                <span class="headline">Modelo de Impressão</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6"></v-col>
                    <v-col cols="12" sm="6">
                       <v-select
                        v-model="modelo"
                        item-value="id"
                        item-text="descricao"
                        :items="modelosImpressao"
                        label="Modelo de Impressão"
                        outlined
                        return-object
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" text @click="sair()">Cancelar</v-btn>
                 <v-btn color="blue darken-1" text @click="gerarHTML()">Vizualizar</v-btn>
               </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>

  <!--================================================================================== -->

    </div>
    </template>
<script>
import axios from '../../../plugins/axios'
import impressao from '../../../utilitarios/impressao.utilitario'
import utilitarios from '../../../plugins/utilitarios'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
  props: {
    disciplinas: {
      required: true
    },
    curso: {
      type: Object,
      required: true
    },
    anolectivo: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    modelosImpressao: [{ id: 1, descricao: 'IMS' }, { id: 2, descricao: 'Local' }],
    modelo: { id: 1, descricao: 'IMS' },
    relatorio: ls.get('relatorio-estudante'),
    overlay: false,
    html: ``,
    disciplinasPrimeiroAno: [],
    disciplinasSegundoAno: [],
    disciplinasTerceiroAno: [],
    disciplinasQuartoAno: [],
    configuracoesReport: ls.get('configuracoesReport')
  }),
  computed: {
    instituicaodescricao () {
      return ls.get('instituicaodescricao')
    },

    instituicaoId () {
      return ls.get('i_id')
    },
    isModeloIMS () {
      return this.modelo.id === 2 ? ls.get('i_id') : 1
    }
  },
  created  () {
    this.gerarHTML()
  },
  methods: {

    descricaoEscola () {
      let configuracaoInstituto = ls.get('configuracoesReport').filter(c => c.obs === 'nome_escola')
      return (this.instituicaoId === 1) ? (configuracaoInstituto[0].valor).toUpperCase() : (this.curso.idCurso <= 24 ? this.instituicaodescricao.toUpperCase() : (configuracaoInstituto[1].valor).toUpperCase())
    },
    getlogotipo () {
      let logotipoInstituto = ls.get('configuracoesReport').filter(c => c.chave === 'logotipo2')
      return (ls.get('isintegrado') === 0) ? ls.get('insignia') : (this.curso.idCurso <= 24 ? ls.get('logotipo') : (logotipoInstituto[0].valor))
    },
    async defaultIMS () {
      try {
        let template = ``
        this.disciplinasPrimeiroAno = this.disciplinas.filter(d => d.anoacademico === 1 && d.idCurso === this.curso.idCurso && d.anolectivo === this.anolectivo.descricao)
        this.disciplinasSegundoAno = this.disciplinas.filter(d => d.anoacademico === 2 && d.idCurso === this.curso.idCurso && d.anolectivo === this.anolectivo.descricao)
        this.disciplinasTerceiroAno = this.disciplinas.filter(d => d.anoacademico === 3 && d.idCurso === this.curso.idCurso && d.anolectivo === this.anolectivo.descricao)
        this.disciplinasQuartoAno = this.disciplinas.filter(d => d.anoacademico === 4 && d.idCurso === this.curso.idCurso && d.anolectivo === this.anolectivo.descricao)
        template = this.relatorio.filter(r => r.idinstituicao == 1)

        let documentoiter = template[0].documentoiteracao1
        let documentoiteracao = template[0].documentoiteracao2
        let documentoiteracao2 = template[0].documentoiteracao2
        let documentoiteracao3 = template[0].documentoiteracao2
        let documentoiteracao4 = template[0].documentoiteracao2
        template = template[0].documento

        let dados = ``
        let dados2 = ``
        let dados3 = ``
        let dados4 = ``

        template = template.replace(/{{insignia}}/g, ls.get('insignia'))
        template = template.replace(/{{curso}}/g, this.curso.descricao)
        template = template.replace(/{{anolectivo}}/g, this.anolectivo.novadescricao)

        for (let index = 0; index < this.disciplinasPrimeiroAno.length; index++) {
          const element = this.disciplinasPrimeiroAno[index]
          let iteracao = documentoiter
          iteracao = iteracao.replace(/{{indice}}/g, index + 1)
          iteracao = iteracao.replace(/{{disciplina}}/g, element.descricao)
          iteracao = iteracao.replace(/{{bienal}}/g, this.descricaoEstadoBienal(element.bienal))
          iteracao = iteracao.replace(/{{classBienal}}/g, element.classBienal)
          dados += iteracao
        }
        documentoiteracao = documentoiteracao.replace(/{{classe}}/g, '10ª Classe')
        documentoiteracao = documentoiteracao.replace(/{{dados}}/g, dados)

        for (let index = 0; index < this.disciplinasSegundoAno.length; index++) {
          const element = this.disciplinasSegundoAno[index]
          let iteracao = documentoiter
          iteracao = iteracao.replace(/{{indice}}/g, index + 1)
          iteracao = iteracao.replace(/{{disciplina}}/g, element.descricao)
          iteracao = iteracao.replace(/{{bienal}}/g, this.descricaoEstadoBienal(element.bienal))
          iteracao = iteracao.replace(/{{classBienal}}/g, element.classBienal)
          dados2 += iteracao
        }
        documentoiteracao2 = documentoiteracao2.replace(/{{classe}}/g, '11ª Classe')
        documentoiteracao2 = documentoiteracao2.replace(/{{dados}}/g, dados2)

        for (let index = 0; index < this.disciplinasTerceiroAno.length; index++) {
          const element = this.disciplinasTerceiroAno[index]
          let iteracao = documentoiter
          iteracao = iteracao.replace(/{{indice}}/g, index + 1)
          iteracao = iteracao.replace(/{{disciplina}}/g, element.descricao)
          iteracao = iteracao.replace(/{{bienal}}/g, this.descricaoEstadoBienal(element.bienal))
          iteracao = iteracao.replace(/{{classBienal}}/g, element.classBienal)
          dados3 += iteracao
        }
        documentoiteracao3 = documentoiteracao3.replace(/{{classe}}/g, '12ª Classe')
        documentoiteracao3 = documentoiteracao3.replace(/{{dados}}/g, dados3)

        for (let index = 0; index < this.disciplinasQuartoAno.length; index++) {
          const element = this.disciplinasQuartoAno[index]
          let iteracao = documentoiter
          iteracao = iteracao.replace(/{{indice}}/g, index + 1)
          iteracao = iteracao.replace(/{{disciplina}}/g, element.descricao)
          iteracao = iteracao.replace(/{{bienal}}/g, this.descricaoEstadoBienal(element.bienal))
          iteracao = iteracao.replace(/{{classBienal}}/g, element.classBienal)
          dados4 += iteracao
        }
        documentoiteracao4 = documentoiteracao4.replace(/{{classe}}/g, '13ª Classe')
        documentoiteracao4 = documentoiteracao4.replace(/{{dados}}/g, dados4)

        template = template.replace(/{{tabelas}}/g, documentoiteracao + '' + documentoiteracao2 + '' + documentoiteracao3 + '' + documentoiteracao4)
        let options = { 'format': 'A4',
          'border': {
            'right': '12mm',
            'left': '12mm'
          },
          'header': {
            'height': '10mm'
          },
          'footer': {
            'height': '10mm'

          } }
        impressao.htmlToPDF(template, options, ls.get('urlReport'), ls.get('idPessoa'))
      } catch (error) {
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao criar o PDF' })
      }
    },
    async gerarHTML () {
      try {
        this.$store.state.isloading = true
        this.relatorio = await axios.get('/obterRelatorioByDescricao/pc').then(res => res.data)
        this.relatorio = this.relatorio.filter(r => r.idinstituicao === this.isModeloIMS)

        if (this.relatorio.length) {
          if (this.isModeloIMS) {
            this.defaultIMS()
          } else {
            let componente1 = this.disciplinas.filter(d => d.componente === 1 && d.idCurso === this.curso.idCurso && d.anolectivo === this.anolectivo.descricao)
            let componente2 = this.disciplinas.filter(d => d.componente === 2 && d.idCurso === this.curso.idCurso && d.anolectivo === this.anolectivo.descricao)
            let componente3 = this.disciplinas.filter(d => d.componente !== 1 && d.componente !== 2 && d.idCurso === this.curso.idCurso && d.anolectivo === this.anolectivo.descricao)
            let dados = ``
            let dados2 = ``
            let dados3 = ``
            let aux = []
            let aux2 = []
            let aux3 = []
            componente1.forEach(element => {
              const index = aux.indexOf(element.descricao)
              if (index === -1) {
                let documentoiter = this.relatorio[0].documentoiteracao1
                let iteracao = documentoiter
                iteracao = iteracao.replace(/{{disciplina}}/g, element.descricao)
                iteracao = iteracao.replace(/{{is10}}/g, '')
                iteracao = iteracao.replace(/{{is11}}/g, '')
                iteracao = iteracao.replace(/{{is12}}/g, '')
                iteracao = iteracao.replace(/{{is13}}/g, '')
                dados += iteracao
                aux.push(element.descricao)
              }
            })

            componente2.forEach(element => {
              const index = aux2.indexOf(element.descricao)
              if (index === -1) {
                let documentoiter = this.relatorio[0].documentoiteracao1
                let iteracao = documentoiter
                iteracao = iteracao.replace(/{{disciplina}}/g, element.descricao)
                iteracao = iteracao.replace(/{{is10}}/g, '')
                iteracao = iteracao.replace(/{{is11}}/g, '')
                iteracao = iteracao.replace(/{{is12}}/g, '')
                iteracao = iteracao.replace(/{{is13}}/g, '')
                dados2 += iteracao
                aux2.push(element.descricao)
              }
            })

            componente3.forEach(element => {
              const index = aux3.indexOf(element.descricao)
              if (index === -1) {
                let documentoiter = this.relatorio[0].documentoiteracao1
                let iteracao = documentoiter
                iteracao = iteracao.replace(/{{disciplina}}/g, element.descricao)
                iteracao = iteracao.replace(/{{is10}}/g, '')
                iteracao = iteracao.replace(/{{is11}}/g, '')
                iteracao = iteracao.replace(/{{is12}}/g, '')
                iteracao = iteracao.replace(/{{is13}}/g, '')
                dados3 += iteracao
                aux.push(element.descricao)
              }
            })
            this.html = this.relatorio[0].documento
            this.html = this.html.replace(/{{insignia}}/g, ls.get('insignia'))
            this.html = this.html.replace(/{{logotipo}}/g, this.getlogotipo())
            this.html = this.html.replace(/{{curso}}/g, this.curso.descricao)
            this.html = this.html.replace(/{{areaformacao}}/g, (this.curso.areaformacao ? this.curso.areaformacao : ''))
            this.html = this.html.replace(/{{anolectivo}}/g, this.anolectivo.novadescricao)
            this.html = this.html.replace(/{{dataacual}}/g, utilitarios.correntDateByUnderstanding())

            this.html = this.html.replace(/{{componente1}}/g, dados)
            this.html = this.html.replace(/{{componente2}}/g, dados2)
            this.html = this.html.replace(/{{componente3}}/g, dados3)

            this.html = this.html.replace(/{{componente1_total_10}}/g, '')
            this.html = this.html.replace(/{{componente1_total_11}}/g, '')
            this.html = this.html.replace(/{{componente1_total_12}}/g, '')
            this.html = this.html.replace(/{{componente1_total_13}}/g, '')

            this.html = this.html.replace(/{{componente2_total_10}}/g, '')
            this.html = this.html.replace(/{{componente2_total_11}}/g, '')
            this.html = this.html.replace(/{{componente2_total_12}}/g, '')
            this.html = this.html.replace(/{{componente2_total_13}}/g, '')

            this.html = this.html.replace(/{{componente3_total_10}}/g, '')
            this.html = this.html.replace(/{{componente3_total_11}}/g, '')
            this.html = this.html.replace(/{{componente3_total_12}}/g, '')
            this.html = this.html.replace(/{{componente3_total_13}}/g, '')

            this.html = this.html.replace(/{{total_10}}/g, '')
            this.html = this.html.replace(/{{total_11}}/g, '')
            this.html = this.html.replace(/{{total_12}}/g, '')
            this.html = this.html.replace(/{{total_13}}/g, '')
            let options = { 'format': 'A4',
              'border': {
                'right': '12mm',
                'left': '12mm'
              },
              'header': {
                'height': '10mm'
              },
              'footer': {
                'height': '10mm'

              } }
            impressao.htmlToPDF(this.html, options, ls.get('urlReport'), ls.get('idPessoa'))
          }
        } else {
          this.$store.state.isloading = false
          Swal.fire({ icon: 'info', title: '', text: 'Plano curricular não configurado!' })
        }
      } catch (error) {
        console.log(error)
        this.sair()
        this.$store.state.isloading = false
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao criar o PDF' })
      }
    },
    sair () {
      this.$store.state.isloading = false
      this.overlay = false
    },
    descricaoBienal (bienal) {
      return parseInt(bienal) > 0 ? 'Sim' : ''
    },

    descricaoEstadoBienal (bienal) {
      let bienal_ = parseInt(bienal)
      if (bienal_ == 1) {
        return 'Continua na classe seguinte'
      } else {
        if (bienal_ > 1) { return 'Continuação da classe anterior' } else { return '' }
      }
      // return 'Continuação da classe anterior'
    }
  }
}

</script>
